<template>
  <div>
    <backButton></backButton>
    Deposit Page
  </div>
</template>
<script>
import backButton from "../components/backButton.vue";
export default {
  components: {
    BackButton: backButton,
  },
  methods: {},
};
</script>
<style lang="scss"></style>
